module.exports = __webpack_public_path__ + "img/sign-out.d1413baa.svg";